import React from "react";
import { Formik } from "formik";
import { Col, Form, Row } from "react-bootstrap";

export function StudentRegistrationCancellationForm({
  btnRef,
  cancelRegistrations
}) {
  return (
    <Formik
      enableReinitialize={true}
      initialValues={{ explanation: ""}}
      onSubmit={(values) => {
        cancelRegistrations(values);
      }}
    >
      {({ handleSubmit, handleChange, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>          
          <Form.Group as={Row} controlId="explanation">
            <Form.Label column sm={4}>
              Açıklama
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                as="textarea"
                rows="2"
                placeholder="Açıklama"
                value={values.explanation}
                onChange={handleChange}
              />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}